export default __webpack_public_path__ + "static/property-banner-mobile-2c7a400b3c63e4ca66dbdf3796d2a737.jpg";